import FormWizard2Container from "../../../../../Components/Forms&Table/Forms/FormLayout/FormWizard2/FormWizard2Container";

const FormWizard2 = () => {
  return <FormWizard2Container />;
};

export default FormWizard2;
